import React, { createContext, useMemo } from 'react';
import PropTypes from 'prop-types';

export const RentGptContext = createContext();

const ContextApp = ({ children }) => (
  <RentGptContext.Provider value={useMemo(() => ({}), [])}>{children}</RentGptContext.Provider>
);

ContextApp.propTypes = {
  children: PropTypes.element.isRequired,
};
export default ContextApp;
